import css from './reward.module.scss';
import {RewardProps} from './reward.types';

export const Reward = ({thumb, title, set}: RewardProps): JSX.Element => {
	return (
		<div className={css.container}>
			<div className={css.thumb}>
				<img src={thumb} />
			</div>
			<div className={css.detail}>
				<div className={css.title}>{title}</div>
				<div className={css.set}>{set} SET</div>
			</div>
		</div>
	);
};
